@import '../../../globals/main';

//standalone no image/ default
pn-stats-info {
  .pn-stats-info__container {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .pn-stats-info__container__map {
    display: none;
  }

  .pn-stats-info-image-container {
    display: none;
  }

  .pn-stats-info__container__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.4rem 2.4rem 1.6rem;

    width: 100%;
    background-color: $blue900;

    border-radius: 2.4rem;

    @media screen and (min-width: $min-width-lg) {
      padding: 4rem 2.4rem 1.6rem;
    }

    @media screen and (min-width: $min-width-xl) {
      padding: 5.6rem 2.4rem 3.2rem;
    }
  }

  .pn-stats-info__container__content__heading {
    color: $coral400;
    margin-bottom: 2.4rem;
    align-self: center;
    text-align: center;

    font-size: 3rem;
    line-height: 110%;

    @media screen and (min-width: $min-width-xl) {
      font-weight: 700;
      font-size: 4.8rem;
    }
  }

  .pn-stats-info__container__content__data {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;

    width: 100%;
    //one item

    pn-stats-info-data:first-child:nth-last-child(2n),
    pn-stats-info-data:first-child:nth-last-child(2n) ~ pn-stats-info-data {
      width: 50%;
    }

    @media screen and (min-width: $min-width-md) {
      pn-stats-info-data:first-child:nth-last-child(1) {
        width: 100%;
      }

      // two items
      pn-stats-info-data:first-child:nth-last-child(2),
      pn-stats-info-data:first-child:nth-last-child(2) ~ pn-stats-info-data {
        width: 50%;
      }

      //multiples of  tree items
      pn-stats-info-data:first-child:nth-last-child(3n),
      pn-stats-info-data:first-child:nth-last-child(3n) ~ pn-stats-info-data {
        width: 33%;
      }

      //8 items
      pn-stats-info-data:first-child:nth-last-child(8),
      pn-stats-info-data:first-child:nth-last-child(8) ~ pn-stats-info-data {
        width: 25%;
      }
    }

    .pn-stats-info-data__container {
      justify-content: flex-start;
      min-height: 0;
      padding: 2.4rem;

      @media screen and (min-width: $min-width-md) {
        min-height: 0;
      }
      @media screen and (min-width: $min-width-lg) {
        min-height: 0;
      }
      @media screen and (min-width: $min-width-xl) {
        min-height: 0;
      }
    }
  }
}

// WITH BACKGROUND -------------------------------------

pn-stats-info[data-stats-image='background'] {
  .pn-stats-info__container__map {
    display: none;

    @media screen and (min-width: $min-width-md) {
      display: block;
      max-width: 46rem;
      width: 100%;
      background-color: $blue900;
      background-repeat: no-repeat;
      background-position: bottom center;
      background-size: 55%;
    }

    @media screen and (min-width: $min-width-xl) {
      background-size: contain;
    }

    border-top-left-radius: 2.4rem;
    border-bottom-left-radius: 2.4rem;
  }

  .pn-stats-info-image-container {
    display: none;
  }

  .pn-stats-info__container__content {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;
    background-color: $blue900;
    background-repeat: no-repeat;
    background-position: bottom left;
    background-size: 50%;
    background-blend-mode: overlay;

    border-radius: 2.4rem;

    @media screen and (min-width: $min-width-md) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      max-width: 54rem;
      background-position: -999px -999px;
      background-size: 0;
    }

    @media screen and (min-width: $min-width-xl) {
      max-width: 100%;
    }
  }

  .pn-stats-info__container__content__data {
    min-height: 0;
  }
}

// WITH IMAGE--------------------------------------------

pn-stats-info[data-stats-image='image'] {
  .pn-stats-info__container {
    flex-direction: column;
    padding-top: 0;

    @media screen and (min-width: $min-width-lg) {
      flex-direction: row;
    }
  }

  .pn-stats-info__container__map {
    display: none;
  }

  .pn-stats-info-image-container {
    display: block;
    position: relative;

    & [slot='illustration'] {
      border-top-left-radius: 2.4rem;
      border-top-right-radius: 2.4rem;
      & > picture > img {
        width: 100%;
        height: auto;
        border-top-left-radius: 2.4rem;
        border-top-right-radius: 2.4rem;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    @media screen and (min-width: $min-width-lg) {
      display: flex;
      align-items: center;
      background-color: $blue900;
      padding-left: 4rem;
      border-top-left-radius: 2.4rem;
      border-bottom-left-radius: 2.4rem;

      & [slot='illustration'] {
        img {
          clip-path: circle(50%);
          object-fit: cover;
          object-position: center;
          aspect-ratio: 1;
          max-width: 45rem;
        }
      }
    }
  }

  .pn-stats-info__container__content {
    width: 100%;
    max-width: 100%;
    border-bottom-right-radius: 2.4rem;
    border-bottom-left-radius: 2.4rem;
    border-top-right-radius: 0;
    border-top-left-radius: 0;

    @media screen and (min-width: $min-width-md) {
      justify-content: center;
    }

    @media screen and (min-width: $min-width-lg) {
      border-top-right-radius: 2.4rem;
      border-bottom-right-radius: 2.4rem;
      border-bottom-left-radius: 0;
      max-width: 100%;
    }
  }

  .pn-stats-info__container__content__heading {
    @media screen and (min-width: $min-width-lg) {
      font-size: 4.8rem;
    }
  }

  .pn-stats-info__container__content__data {
    width: 100%;
    height: auto;
    min-height: 0;
    .pn-stats-info-data__container {
      justify-content: flex-start;
      min-height: 5.6rem;

      @media screen and (min-width: $min-width-md) {
        min-height: 5.6rem;
        padding: 2.4rem;
      }

      @media screen and (min-width: $min-width-xl) {
        min-height: 5rem;
      }
    }

    .pn-stats-info-data__container__content__data {
      @media screen and (min-width: $min-width-lg) {
        font-size: 5.6rem;
      }
    }

    .pn-stats-info-data__container__content__unit {
      @media screen and (min-width: $min-width-lg) {
        font-size: 5.6rem;
      }
    }
  }
}

//bleed
.bleed-container:has(pn-stats-info) {
  padding: 0;
  margin-bottom: 3rem;

  overflow: hidden;

  .container > .mb-5 {
    margin-bottom: 0 !important; //counteracts mb-5 in pn-project, sorry for the !important
  }
  .statsblock {
    margin-bottom: 0 !important; //counteracts mb-5 in pn-project sorry for the !important
  }
}

//i combo
.comboquotestatsblock {
  pn-stats-info {
    width: 100%;

    .pn-stats-info__container {
      display: flex;
      flex-direction: row;
      justify-content: center;

      padding-top: 2rem;
      @media screen and (min-width: $min-width-md) {
        padding-top: 6rem;
      }

      @media screen and (min-width: $min-width-xl) {
        padding-top: 8rem;
      }
    }

    .pn-stats-info__container__map {
      display: none;

      @media screen and (min-width: $min-width-md) {
        display: block;
        max-width: 46rem;
        width: 100%;
        background-color: $blue900;
        background-repeat: no-repeat;
        background-position: bottom center;
        background-size: 55%;
      }

      @media screen and (min-width: $min-width-xl) {
        background-size: contain;
      }
    }

    .pn-stats-info-image-container {
      display: none;
    }

    .pn-stats-info__container__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 1rem;

      //map
      width: 100%;
      background-color: $blue900;
      background-repeat: no-repeat;
      background-position: bottom left;
      background-size: 50%;
      background-blend-mode: overlay;
      padding-bottom: 2rem;
      @media screen and (min-width: $min-width-md) {
        max-width: 54rem;
        background-position: -999px -999px;
        background-size: 0;
        padding-bottom: 4rem;
        padding-right: 4rem;
      }

      @media screen and (min-width: $min-width-xl) {
        max-width: 100%;
        padding-bottom: 6rem;
        padding-right: 6rem;
      }
    }

    .pn-stats-info__container__content__heading {
      color: $coral400;
      margin-bottom: 2.4rem;
      align-self: center;
      text-align: center;

      font-size: 3rem;
      line-height: 110%;

      @media screen and (min-width: $min-width-xl) {
        font-weight: 700;
        font-size: 4.8rem;
      }
    }

    .pn-stats-info__container__content__data {
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      min-height: 20rem;

      @media screen and (min-width: $min-width-xxl) {
        width: 65rem;
      }
    }
  }
}

//colors
pn-stats-info[data-stats-background-color='bluedarkest'] {
  .pn-stats-info__container__content,
  .pn-stats-info__container__map {
    background-color: $blue900;
  }

  .pn-stats-info-image-container {
    background-color: transparent;
    [slot='illustration'] {
      background-color: $blue900;
    }
    @media screen and (min-width: $min-width-lg) {
      background-color: $blue900;
    }
  }

  .pn-stats-info__container__content__heading,
  .pn-stats-info-data__container__content {
    color: $coral400;
  }

  .pn-stats-info-data__container__content__preamble {
    color: $white;
  }
}

pn-stats-info[data-stats-background-color='greendark'] {
  .pn-stats-info__container__content,
  .pn-stats-info__container__map {
    background-color: $green700;
  }

  .pn-stats-info-image-container {
    background-color: transparent;
    [slot='illustration'] {
      background-color: $green700;
    }
    
    @media screen and (min-width: $min-width-lg) {
      background-color: $green700;
    }
  }

  .pn-stats-info__container__content__heading,
  .pn-stats-info-data__container__content {
    color: $white;
  }

  .pn-stats-info-data__container__content__preamble {
    color: $white;
  }
}

pn-stats-info[data-stats-background-color='green25'] {
  .pn-stats-info__container__content,
  .pn-stats-info__container__map {
    background-color: $green25;
  }

  .pn-stats-info-image-container {
    background-color: transparent;
    [slot='illustration'] {
      background-color: $green25;
    }
    @media screen and (min-width: $min-width-lg) {
      background-color: $green25;
    }
  }

  .pn-stats-info__container__content__heading,
  .pn-stats-info-data__container__content {
    color: $blue700;
  }

  .pn-stats-info-data__container__content__preamble {
    color: $blue900;
  }
}

pn-stats-info[data-stats-background-color='gray100'] {
  .pn-stats-info__container__content,
  .pn-stats-info__container__map {
    background-color: $gray100;
  }

  .pn-stats-info-image-container {
    background-color: transparent;
    [slot='illustration'] {
      background-color: $gray100;
    }
    @media screen and (min-width: $min-width-lg) {
      background-color: $gray100;
    }
  }

  .pn-stats-info__container__content__heading,
  .pn-stats-info-data__container__content {
    color: $blue700;
  }

  .pn-stats-info-data__container__content__preamble {
    color: $blue900;
  }
}

pn-stats-info[data-stats-background-color='bluedefault'] {
  .pn-stats-info__container__content,
  .pn-stats-info__container__map {
    background-color: $blue400;
  }

  .pn-stats-info-image-container {
    background-color: transparent;
    [slot='illustration'] {
      background-color: $blue400;
    }
    @media screen and (min-width: $min-width-lg) {
      background-color: $blue400;
    }
  }

  .pn-stats-info__container__content__heading,
  .pn-stats-info-data__container__content {
    color: $white;
  }

  .pn-stats-info-data__container__content__preamble {
    color: $blue900;
  }
}

pn-stats-info[data-stats-background-color='blue25'] {
  .pn-stats-info__container__content,
  .pn-stats-info__container__map {
    background-color: $blue25;
  }

  .pn-stats-info-image-container {
    background-color: transparent;
    [slot='illustration'] {
      background-color: $blue25;
    }
    @media screen and (min-width: $min-width-lg) {
      background-color: $blue25;
    }
  }

  .pn-stats-info__container__content__heading,
  .pn-stats-info-data__container__content {
    color: $blue700;
  }

  .pn-stats-info-data__container__content__preamble {
    color: $blue900;
  }
}

pn-stats-info[data-stats-background-color='coral25'] {
  .pn-stats-info__container__content,
  .pn-stats-info__container__map {
    background-color: $coral25;
  }

  .pn-stats-info-image-container {
    background-color: transparent;
    [slot='illustration'] {
      background-color: $coral25;
    }
    @media screen and (min-width: $min-width-lg) {
      background-color: $coral25;
    }
  }

  .pn-stats-info__container__content__heading,
  .pn-stats-info-data__container__content {
    color: $blue700;
  }

  .pn-stats-info-data__container__content__preamble {
    color: $blue900;
  }
}

pn-stats-info[data-stats-background-color='gray25'] {
  .pn-stats-info__container__content,
  .pn-stats-info__container__map {
    background-color: $gray25;
  }

  .pn-stats-info-image-container {
    background-color: transparent;
    [slot='illustration'] {
      background-color: $gray25;
    }
    @media screen and (min-width: $min-width-lg) {
      background-color: $gray25;
    }
  }

  .pn-stats-info__container__content__heading,
  .pn-stats-info-data__container__content {
    color: $blue700;
  }

  .pn-stats-info-data__container__content__preamble {
    color: $blue900;
  }
}
